// extracted by mini-css-extract-plugin
module.exports = {"container":"SnackBarError_container__vHQhP"};